<template>
  <div :class="formGroupClass">
    <slot name="before"/>
    <div class="form-fieldhelp">
      <label>?</label>
      <div class="form-fieldhelp-text">
        <div>При наличии
        </div>
      </div>
    </div>
    <label :for="inputId" class="control-label">{{ inputLabel }}</label>
    <input
        type="email"
        class="form-control"
        :id="inputId"
        :disabled="disabled"
        v-model="inputValue"
        @blur="checkEmail"
    />
    <div v-if="emailIsntCorrect" class="help-block error-text">
      Неверный формат электронной почты
    </div>
  </div>
</template>

<script>
import applicationInputMixin from '../../../../mixins/applicationInputMixin'
import applicationFormMixin from '../../../../mixins/applicationFormMixin'
import visitorsSectionMixin from '../../../../mixins/application-form/visitorsSectionMixin'
import visitorInputMixin from '../../../../mixins/application-form/visitorInputMixin'

export default {
  name: 'VisitorEmailInput',

  data: function() {
    return {
      emailIsntCorrect: false
    }
  },

  mixins: [
    applicationInputMixin,
    applicationFormMixin,
    visitorsSectionMixin,
    visitorInputMixin
  ],

  props: {
    inputLabel: {
      default: 'Адрес электронной почты'
    },

    inputName: {
      default: 'email'
    }
  },

  computed: {
    inputId () {
      return `form-visitor-email-${this.visitorIndex}`
    }

  },
  methods: {
    checkEmail() {
      this.emailIsntCorrect = !!(this.inputValue !== null && this.inputValue.length > 0 && !/^[^@]+@\w+(\.\w+)+\w$/.test(this.inputValue))
    }
  }
}
</script>
